





























































































































import { elementIsVisibleInViewport } from '~/utils/dom'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import SellerRow from '~/components/car/classifieds/search/results/rows/main/SellerRow.vue'
import ClassifiedSearchResultsFooter from '~/components/car/classifieds/search/results/ClassifiedSearchResultsFooter.vue'
import ClassifiedSearchResultsHeader from '~/components/car/classifieds/search/results/ClassifiedSearchResultsHeader.vue'
import ClassifiedSearchNoResults from '~/components/car/classifieds/search/ClassifiedSearchNoResults.vue'
import { ViewType } from '~/models/shared/types'
import {
  computed,
  defineComponent,
  defineVue3AsyncComponent,
  nextTick,
  ref,
  watch,
  useRoute
} from '~/utils/nuxt3-migration'
import { useSearchRowsAds } from '~/compositions/ad'
import WantedPartsRow from '~/components/car/classifieds/search/results/rows/main/WantedPartsRow.vue'
import ScamWarningAlert from '~/components/car/ScamWarningAlert.vue'
import CPosting from '~/components/shared/configurable/ad/CPosting.vue'
import { useNamespacedStore } from '~/compositions/store'
import { useUserAgent } from '~/compositions/user-agent'
import ClassifiedSearchResultsRowListView from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowListView.vue'
import ClassifiedSearchResultsRowGalleryView from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowGalleryView.vue'
import ClassifiedSearchActionsService from '~/services/search/ClassifiedSearchActionsService'
import { useDeps } from '~/compositions/dependency-container'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'

export default defineComponent({
  components: {
    CShimmer,
    CPosting,
    ScamWarningAlert,
    AdminMassActions: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/search/results/AdminMassActions.vue')
    ),
    ClassifiedSearchResultsFooter,
    ClassifiedSearchResultsHeader,
    ClassifiedSearchNoResults,
    SellerRow,
    AutoRefreshButton: defineVue3AsyncComponent(() =>
      import('~/components/car/wanted-parts/AutoRefreshButton.vue')
    )
  },
  setup() {
    const {
      state: classifiedSearchState,
      getters: classifiedSearchGetters
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const [classifiedSearchActionsService] = useDeps(
      ClassifiedSearchActionsService
    )
    const { rowsAds, sellersAds } = useSearchRowsAds()
    const { isPc, isMobile } = useUserAgent()
    const route = useRoute()

    const rowsContainerRef = ref<HTMLElement>()

    const isWantedPartsSearch = computed(() =>
      classifiedSearchGetters('isWantedPartsSearch')
    )

    const shouldDisplayAds = computed(() =>
      classifiedSearchGetters('shouldDisplayAds')
    )

    const adsKeyValues = computed(() =>
      classifiedSearchGetters('getAdsKeyValues')
    )

    const showSellers = computed(() => classifiedSearchGetters('showSellers'))

    const inDealerSiteSearch = computed(() =>
      classifiedSearchGetters('inDealerSiteSearch')
    )

    const inBlackFridaySearch = computed(() =>
      classifiedSearchGetters('inBlackFridaySearch')
    )

    const inDealsSearch = computed(() =>
      classifiedSearchGetters('inDealsSearch')
    )

    const isDeletedSearch = computed(() =>
      classifiedSearchGetters('isDeletedSearch')
    )

    const sellerRows = computed(() => classifiedSearchState.sellerRows)

    const rows = computed(() => classifiedSearchState.rows)

    const loadingResults = computed(() => classifiedSearchState.loading.results)

    const viewType = computed(() => classifiedSearchState.viewType)

    const searchId = computed(() => classifiedSearchState.searchId)

    const userIsGuest = computed(() => userGetters('isGuest'))

    const userIsAdmin = computed(() => userGetters('isAdmin'))

    const inMyClassifiedsSearch = computed(
      () => route.value.name === '__classifieds_search_my_classifieds'
    )

    const rowComponent = computed(() => {
      if (isWantedPartsSearch.value) {
        return WantedPartsRow
      }

      return viewType.value === ViewType.GALLERY
        ? ClassifiedSearchResultsRowGalleryView
        : ClassifiedSearchResultsRowListView
    })

    const rowsContainerClasses = computed(() => {
      if (isWantedPartsSearch.value) {
        return 'tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6'
      }

      return viewType.value === ViewType.LIST
        ? 'tw-grid-cols-1 tw-gap-4 xl:tw-gap-6'
        : 'tw-grid-cols-1 sm:tw-grid-cols-2 xl:tw-grid-cols-3 2xl:tw-grid-cols-4 tw-gap-4 xl:tw-gap-6'
    })

    const showScamWarningAlert = computed(
      () =>
        userIsGuest.value &&
        inMyClassifiedsSearch.value &&
        !inDealerSiteSearch.value
    )

    const showAdminMassActions = computed(
      () =>
        userIsAdmin.value &&
        !showSellers.value &&
        !inDealsSearch.value &&
        !inBlackFridaySearch.value &&
        !isDeletedSearch.value
    )

    watch(searchId, async () => {
      if (isPc.value && rowsContainerRef.value) {
        await nextTick()
        const rowsContainerIsVisible = elementIsVisibleInViewport(
          rowsContainerRef.value
        )

        if (!rowsContainerIsVisible) {
          window.scroll(0, 0)
        }
      }
    })

    return {
      rowsAds,
      rowsContainerRef,
      sellersAds,
      rowComponent,
      isWantedPartsSearch,
      showScamWarningAlert,
      viewType,
      isMobile,
      shouldDisplayAds,
      userIsAdmin,
      showSellers,
      adsKeyValues,
      rows,
      sellerRows,
      loadingResults,
      showAdminMassActions,
      rowsContainerClasses,
      classifiedSearchActionsService
    }
  }
})
